module.exports = __webpack_public_path__ + "static/media/kentall-tech_logo_hor.73bef0ca.png";